import React from 'react';
import './Banner.css';

const Banner: React.FC = () => {
    return (
        <a href="/">
            <header className="banner">
                <h1>Hugh Selway-Clarke</h1>
            </header>
        </a>
    );
};

export default Banner; 